    window.trackingFloodlight = function (key, value) {
      var axel = Math.random() + "";
      var a = axel * 10000000000000;
      var src = "";
      switch (key) {
        case "storelocatorsearch":
          src =
            '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/940064767/?label=Fi5BCM-EkIEBEP__oMAD&amp;guid=ON&amp;script=0"/>';
          //src = '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/988722816/?label=5Gz1CPWx_4ABEIDtutcD&amp;guid=ON&amp;script=0"/>';
          break;
        case "appstore":
          src =
            '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/940064767/?label=zWzzCPb4poEBEP__oMAD&amp;guid=ON&amp;script=0"/>';
          //src = '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/988722816/?label=rYXUCNKy_4ABEIDtutcD&amp;guid=ON&amp;script=0"/>';
          break;
        case "storeclick":
          src =
            '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/940064767/?label=VR76CIL5poEBEP__oMAD&amp;guid=ON&amp;script=0"/>';
          //src = '<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/988722816/?label=a0q6COieloEBEIDtutcD&amp;guid=ON&amp;script=0"/>';
          break;
        default:
          break;
      }

      if (src.length > 0) {
        //console.log('image src: ' + src)
        var html = src;
        $("body").append(html);
      }
    };

    window.trackGTM = function (key, varstr, redirecturl) {
      var contentstr = [];
      var isover21 = "unknown";
      isover21 = cookieStorage.getCookie("userAge");
      var event = [];

      switch (key) {
        case "scroll25":
          event = { event: "gtm_scroll_25" };
          break;
        case "scroll50":
          event = { event: "gtm_scroll_50" };
          break;
        case "scroll75":
          event = { event: "gtm_scroll_75" };
          break;
        case "scroll100":
          event = { event: "gtm_scroll_100" };
          break;
        case "topnav_home":
          event = { event: "gtm_globalnav_home" };
          break;
        case "topnav_storeicon":
          event = { event: "gtm_globalnav_stores" };
          break;
        case "topnav_hamburger":
          event = { event: "gtm_globalnav_open" };
          break;
        case "topnav_offers":
          event = { event: "gtm_globalnav_offers" };
          break;
        case "topnav_scratchpower":
          event = { event: "gtm_globalnav_scratchpower" };
          break;
        case "topnav_toomgis":
          event = { event: "gtm_globalnav_toomgis" };
          break;
        case "topnav_location":
          event = { event: "gtm_globalnav_locations" };
          break;
        case "topnav_language":
          event = { event: "gtm_globalnav_language" };
          break;
        case "topnav_21products":
          event = { event: "gtm_globalnav_21products" };
          break;
        case "nav_jobs":
          event = { event: "gtm_globalnav_jobs" };
          break;
        case "topnav_search":
          event = { event: "gtm_globalnav_search_submit" };
          break;
        case "nav_facebook":
          event = { event: "gtm_globalnav_social_facebook" };
          break;
        case "nav_instagram":
          event = { event: "gtm_globalnav_social_instagram" };
          break;
        case "nav_twitter":
          event = { event: "gtm_globalnav_social_twitter" };
          break;
        case "nav_youtube":
          event = { event: "gtm_globalnav_social_youtube" };
          break;
        case "footer_facebook":
          event = { event: "gtm_globalfooter_social_facebook" };
          break;
        case "footer_instagram":
          event = { event: "gtm_globalfooter_social_instagram" };
          break;
        case "footer_twitter":
          event = { event: "gtm_globalfooter_social_twitter" };
          break;
        case "footer_youtube":
          event = { event: "gtm_globalfooter_social_youtube" };
          break;
        case "footer_jobs":
          event = { event: "gtm_globalfooter_jobs" };
          break;
        case "footer_21plus":
          event = { event: "gtm_globalfooter_21plus" };
          break;
        case "footer_legal":
          event = { event: "gtm_globalfooter_legal" };
          break;
        case "footer_privacy":
          event = { event: "gtm_globalfooter_privacy" };
          break;
        case "footer_franchise":
          event = { event: "gtm_globalfooter_franchise" };
          break;
        case "footer_contact":
          event = { event: "gtm_globalfooter_contact" };
          break;
        case "footer_nutrition":
          event = { event: "gtm_globalfooter_nutrition" };
          break;
        case "global_scratchpower":
          event = { event: "gtm_localfooter_scratchpower_main" };
          break;
        case "global_scratchpower_faq":
          event = { event: "gtm_localfooter_scratchpower_faq" };
          break;
        case "global_scratchpower_rules":
          event = { event: "gtm_localfooter_scratchpower_rules" };
          break;
        case "global_iosapp":
          event = { event: "gtm_localfooter_scratchpower_download_ios" };
          break;
        case "global_androidapp":
          event = { event: "gtm_localfooter_scratchpower_download_android" };
          break;
        case "global_locatorsearch":
          event = { event: "gtm_localfooter_locator_submit" };
          break;
        case "global_usemylocation":
          event = { event: "gtm_localfooter_locator_usemylocation" };
          break;
        case "home_page":
          //event = {'event': 'homepage'};
          //contentstr = "'pageType':'homepage','regionName':'" + userRegion + "'";
          event = {
            pageType: "homepage",
            regionName: userRegion,
            event: "homepage",
          };
          break;
        case "home_pano":
          event = { event: "gtm_homepage_hero" };
          break;
        case "home_locatorsearch":
          event = { event: "gtm_homepage_locator_submit" };
          break;
        case "home_usemylocation":
          event = { event: "gtm_homepage_locator_usemy" };
          break;
        case "home_offer":
          event = { event: "gtm_homepage_offers" };
          break;
        case "home_product":
          event = { event: "gtm_homepage_faves" };
          break;
        case "home_toomgis":
          event = { event: "gtm_homepage_toomgis" };
          break;
        case "home_scratchpower":
          event = { event: "gtm_homepage_scratchpower" };
          break;
        case "storelocator_page":
          //event = {'event': 'storelocator'};
          event = {
            pageType: "storelocator",
            regionName: userRegion,
            event: "storelocator",
          };
          //contentstr = "'pageType':'storelocator','regionName':'" + userRegion + "'";
          break;
        case "storelocator_result":
          //event = {'event': 'gtm_storelocator_results'};
          //contentstr = "'resultsType': '" + varstr + "'";
          event = { resultsType: varstr, event: "gtm_storelocator_results" };
          break;
        case "storelocator_search":
          event = { event: "gtm_storelocator_submit" };
          break;
        case "storelocator_usemylocation":
          event = { event: "gtm_storelocator_usemylocation" };
          break;
        case "storelocator_storeclick":
          event = { event: "gtm_storelocator_result_detail" };
          break;
        case "storelocator_call":
          event = { event: "gtm_storelocator_result_call" };
          break;
        case "storelocator_mapdetail":
          event = { event: "gtm_stationlocator_map_detail" };
          break;
        case "storelocator_direction":
          event = { event: "gtm_stationlocator_map_directions" };
          break;
        case "storelocator_mapcall":
          event = { event: "gtm_stationlocator_map_call" };
          break;
        case "storelocator_searcharea":
          event = { event: "gtm_stationlocator_map_searchthisarea" };
          break;
        case "toomgis_page":
          //event = {'event': 'toomgis'};
          //contentstr = "'pageType':'toomgis','regionName':'" + userRegion + "','over21':'" + isover21 + "'";
          event = {
            pageType: "toomgis",
            regionName: userRegion,
            over21: isover21,
            event: "toomgis",
          };
          break;
        case "toomgis_videostart":
          //event = {'event': 'gtm_toomgis_video_start'};
          event = { videoName: varstr, event: "gtm_toomgis_video_start" };

          break;
        case "toomgis_videoend":
          //event = {'event': 'gtm_toomgis_video_complete'};
          event = { videoName: varstr, event: "gtm_toomgis_video_complete" };
          break;
        case "offer_page":
          //event = {'event': 'offers'};
          //contentstr = "'pageType':'offers','regionName':'" + userRegion + "','over21':'" + isover21 + "'";
          event = {
            pageType: "offers",
            regionName: userRegion,
            over21: isover21,
            event: "offers",
          };
          break;
        //case "offer_hover":
        //event = {'event': 'gtm_offers_hover', 'offername': varstr, };
        //contentstr = "'offername': '" + varstr + "'";
        //contentstr = { 'offername': varstr, 'event': event }
        //break;
        case "offer_coupon":
          event = { event: "gtm_offers_getcoupon" };
          break;
        case "over21_page":
          //event = {'event': 'over21'};
          //contentstr = "'pageType':'over21','regionName':'" + userRegion + "','over21':'" + isover21 + "'";
          event = {
            pageType: "over21",
            regionName: userRegion,
            over21: isover21,
            event: "over21",
          };
          break;
        case "over21_agegate":
          event = { event: "gtm_21plus_agegate_displayed" };
          break;
        case "over21_agegateclick":
          event = { event: "gtm_21plus_agegate_submit" };
          break;
        case "products_page":
          event = {
            pageType: "products",
            contentType: groupType,
            regionName: userRegion,
            over21: isover21,
            event: "products",
          };
          break;
        case "product_arrowleft":
          event = { event: "gtm_products_carousel_arrowleft" };
          break;
        case "product_arrowright":
          event = { event: "gtm_products_carousel_arrowright" };
          break;
        case "product_dot":
          event = { event: "gtm_products_carousel_dot" };
          break;
        case "product_back":
          event = { event: "gtm_products_backtohome" };
          break;
        case "scratchpower_page":
          event = {
            pageType: "scratchpower",
            regionName: userRegion,
            over21: isover21,
            event: "scratchpower",
          };
          break;
        case "scratchpower_iosapp1":
          event = { event: "gtm_scratchpower_hero_download_ios" };

          break;
        case "scratchpower_android1":
          event = { event: "gtm_scratchpower_hero_download_android" };
          break;
        case "scratchpower_rules":
          event = { event: "gtm_scratchpower_rules" };
          break;
        case "scratchpower_faq":
          event = { event: "gtm_scratchpower_faq" };
          break;
        case "scratchpower_iosapp2":
          event = { event: "gtm_scratchpower_secondary_download_ios" };
          break;
        case "scratchpower_android2":
          event = { event: "gtm_scratchpower_secondary_download_android" };
          break;
        case "so1play":
          event = { event: "podcast/start", podcastName: "donut" };
          break;
        case "so1pause":
          event = { event: "podcast/pause", podcastName: "donut" };
          break;
        case "so1drag":
          event = { event: "podcast/drag", podcastName: "donut" };
          break;
        case "so125":
          event = {
            event: "podcast/progress",
            podcastName: "donut",
            progress: "25",
          };
          break;
        case "so150":
          event = {
            event: "podcast/progress",
            podcastName: "donut",
            progress: "50",
          };
          break;
        case "so175":
          event = {
            event: "podcast/progress",
            podcastName: "donut",
            progress: "75",
          };
          break;
        case "so1done":
          event = {
            event: "podcast/progress",
            podcastName: "donut",
            progress: "100",
          };
          break;
        case "so2play":
          event = { event: "podcast/start", podcastName: "asteroids" };
          break;
        case "so2pause":
          event = { event: "podcast/pause", podcastName: "asteroids" };
          break;
        case "so2drag":
          event = { event: "podcast/progress", podcastName: "asteroids" };
          break;
        case "so225":
          event = {
            event: "podcast/progress",
            podcastName: "asteroids",
            progress: "25",
          };
          break;
        case "so250":
          event = {
            event: "podcast/progress",
            podcastName: "asteroids",
            progress: "50",
          };
          break;
        case "so275":
          event = {
            event: "podcast/progress",
            podcastName: "asteroids",
            progress: "75",
          };
          break;
        case "so2done":
          event = {
            event: "podcast/progress",
            podcastName: "asteroids",
            progress: "100",
          };
          break;
        case "so3play":
          event = { event: "podcast/start", podcastName: "freeze" };
          break;
        case "so3pause":
          event = { event: "podcast/pause", podcastName: "freeze" };
          break;
        case "so3drag":
          event = { event: "podcast/drag", podcastName: "freeze" };
          break;
        case "so325":
          event = {
            event: "podcast/progress",
            podcastName: "freeze",
            progress: "25",
          };
          break;
        case "so350":
          event = {
            event: "podcast/progress",
            podcastName: "freeze",
            progress: "50",
          };
          break;
        case "so375":
          event = {
            event: "podcast/progress",
            podcastName: "freeze",
            progress: "75",
          };
          break;
        case "so3done":
          event = {
            event: "podcast/progress",
            podcastName: "freeze",
            progress: "100",
          };
          break;
        case "subscribe_google":
          event = { event: "podcast/subscribe", subscrible: "google" };
          break;
        case "subscribe_apple":
          event = { event: "podcast/subscribe", subscrible: "apple" };
          break;
        case "subscribe_spotify":
          event = { event: "podcast/subscribe", subscrible: "spotify" };
          break;
        case "subscribe_soundcloud":
          event = { event: "podcast/subscribe", subscrible: "soundcloud" };
          break;
        case "subscribe_iheart":
          event = { event: "scratchpower/subscribe", subscrible: "iheart" };
          break;
        case "spvideostart":
          event = {
            videoName: "scratch-power",
            event: "gtm_scratchpower_video_start",
          };
          break;
        case "spvideo25":
          event = { event: "scratch-power/progress", progress: "25" };
          break;
        case "spvideo50":
          event = { event: "scratch-power/progress", progress: "50" };
          break;
        case "spvideo75":
          event = { event: "scratch-power/progress", progress: "75" };
          break;
        case "spvideodone":
          event = {
            videoName: "scratch-power",
            event: "gtm_scratchpower_video_done",
          };
          break;

        case "covid19_learn_more":
          event = { event: "gtm_covid19_learnmore" };
          break;
        case "give_tmgs_learnmore":
          event = { event: "gtm_give_tmgs_learnmore" };
          break;
        case "covid19_learn_more":
          event = { event: "gtm_covid19_learnmore" };
          break;
        case "give_tmgs_learnmore":
          event = { event: "gtm_give_tmgs_learnmore" };
          break;
        case "covid19_storehours_state":
          event = { stateName: varstr, event: "gtm_covid19_storehours_state" };
          break;
        case "offerCTA":
          var stuff = varstr.split(":");
          offername = stuff[0];
          offerindex = stuff[1];
          offercta = stuff[2];
          event = {
            event: "gtm_offers_cta",
            offerName: offername,
            offerIndex: offerindex,
            offerCTA: offercta,
          };
          break;

        // 21 products page
        case "21ProductsCTAClick":
          event = {
            event: "gtm_21products_cta_click",
            label21products: "21products/" + varstr,
          };
          break;

        case "21ProductsImageClick":
          event = {
            event: "gtm_21products_img_click",
            label21products: "21products/" + varstr,
          };
          break;

        // 21+ page detail page return
        case "21ProductsBack":
          event = { event: "gtm_21products_back" };
          break;

        // Toomgis brand addition
        // toomgis hotspots
        case "toomgisHotSpotsCTA":
          event = {
            event: "gtm_toomgishotspots_cta",
            toomgishotspotslabel: "toomgis/click/" + varstr,
          };
          break;

        // toomgistroothslabel
        case "toomgisTroothsVisibility":
          event = {
            event: "gtm_toomgistroothsvisibility",
            toomgistroothslabel: "toomgis/view/trooths",
          };
          break;

        // alternate home page pano for multiple clicks
        case "homepagePanoCTA":
          event = {
            event: "gtm_homepagepano_cta",
            homepagepanolabel: "homepagepano/click/" + varstr,
          };
          break;

        // alternate global footer social links
        case "footerSocialClicks":
          event = {
            event: "gtm_footersocial_clicks",
            footersocialclickslabel: "footer/social/" + varstr,
          };
          break;

        // Homepage brand addition cravenience
        case "homepage_videostart":
          event = {
            event: "gtm_homepage_video_start",
            homepagevideostartlabel: "homepage/video/start/" + varstr,
          };
          break;

        case "homepage_videocomplete":
          event = {
            event: "gtm_homepage_video_complete",
            homepagevideocompletelabel: "homepage/video/complete/" + varstr,
          };
          break;

        case "homepage_playaudio":
          event = {
            event: "gtm_homepage_playaudio",
            homepageplayaudiolabel: "homepage/click/play_audio_" + varstr,
          };
          break;
        //

        case "coffeesubscriptionSPCTA":
          event = { event: "gtm_coffeesubscription_cta", coffeelabel: varstr };
          break;

        // too much giving season
        case "homepageGivingSeason":
          event = {
            event: "gtm_homepage_givingseason",
            homegivingseasonlabel: "homepage/click/",
          };
          break;

        case "givingseasonCTA":
          event = {
            event: "gtm_givingseason_cta",
            givingseasonlabel: "givingseason/" + varstr,
          };
          break;

        // case "covid19_learn_more":
        //     event = { 'event': 'gtm_covid19_learnmore' };
        //     break;

        default:
          break;
      }

      window.dataLayer = window.dataLayer || [];
      if (typeof window.dataLayer != "undefined") {
        window.dataLayer.push(event);
        debug && console.log("EVENT: ", event);
        //console.log("redirect url: ", redirecturl);
        //alert("hold");
      } else {
        debug && console.log("datalayer ubdefined");
      }
    };

    // GA4 tagging 
    window.trackGA4 = function (element, key, varstr) {

      if (typeof element !== "object") {
        element = {}
      }
      if (element === null) {
        element = {}
      }
      if (typeof element.innerText !== "string") {
        element.innerText = ""
      }
      if (typeof element.getAttribute !== "function") {
        element.getAttribute = function () {
          return ""
        }
      }

      console.log("trackGA4", element, key, varstr);
      var event = {};


      var linkURL = "";
      if (element.getAttribute("href")) {
        linkURL = element.getAttribute("href");
        if (typeof window.GA4 !== "undefined") {
          if (typeof window.GA4.GlobalFunctions !== "undefined") {
            if (
              typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined"
            ) {
              linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
            }
          }
        }
      }



      switch (key) {

        // AMPMWD-921
        case "global_locatorsearch":
          linkURL = "/storelocator";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Arrow" button click (or keyboard enter)',
            'link_location': 'footer',
            'link_text': 'submit',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': 'storelocator module',
            'link_url': linkURL,
            'ua_category': 'localfooter',
            'ua_action': 'click',
            'ua_label': 'localfooter/locator_usemylocation'
          };
          break;

        // AMPMWD-1029
        case "global_usemylocation":
          linkURL = "/storelocator";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Use My Location click',
            'link_location': 'footer',
            'link_text': 'Use My Location',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': 'storelocator module',
            'link_url': linkURL,
            'ua_category': 'localfooter',
            'ua_action': 'click',
            'ua_label': 'localfooter/locator_submit'
          };
          break;

        // AMPMWD-922 - AMPM-1054
        case "over21_agegate":
          event = {
            'event': 'ga4_banner_display',
            'banner_display': 'age_gate_modal',
            'link_location': 'modal',
            'component_name': 'agegate',
            'ua_category': 'agegate',
            'ua_action': 'overlay',
            'ua_label': 'agegate/displayed'
          };
          break;

        // AMPMWD-1032
        case "over21_agegateclick_not21":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Not 21 button',
            'link_location': 'modal',
            'link_text': 'I\'m Not 21',
            'link_item': 'agegate click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'agegate',
            'link_url': null,
            'ua_category': 'agegate',
            'ua_action': 'overlay',
            'ua_label': 'agegate/submit'

          };
          break;

        case "over21_agegateclick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Over 21 button',
            'link_location': 'modal',
            'link_text': 'I\'m Over 21',
            'link_item': 'agegate click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'agegate',
            'link_url': linkURL,
            'ua_category': 'agegate',
            'ua_action': 'overlay',
            'ua_label': 'agegate/submit'
          };
          break;

        // case "over21_agegateclick_toomgis":
        //   event = {
        //     'event': 'ga4_custom_link',
        //     'custom_link': 'Meet Toomgis button',
        //     'link_location': 'modal',
        //     'link_text': 'Meet Toomgis',
        //     'link_item': 'agegate click',
        //     'link_detail': null,
        //     'link_action': null,
        //     'link_display': 'button',
        //     'link_position': null,
        //     'link_conversion': 0,
        //     'link_type': null,
        //     'component_name': 'agegate',
        //     'link_url': linkURL,
        //     'ua_category': 'agegate',
        //     'ua_action': 'overlay',
        //     'ua_label': 'agegate/toomgis'

        //   };
        //   break;




        case "home_panoCTA":
          linkURL = "/offers";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Fire event upon click of hero item',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'hero click',
            'link_detail': varstr,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'site_section': 'homepage',
            'link_url': linkURL,
            'ua_category': 'homepage',
            'ua_action': 'click',
            'ua_label': 'homepage/gtm_homepage_pano_cta'

          };
          break;

        case "home_panoDisclaimer":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Fire event upon click of disclaimer link/button',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'legal click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'homepage',
            'ua_action': 'click',
            'ua_label': 'homepage/gtm_homepage_disclaimer'

          };
          break;

        case "home_locatorsearch":
          linkURL = "/storelocator";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Arrow" button click (or keyboard enter) for store locator',
            'link_location': 'hero',
            'link_text': 'submit',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': 'storelocator module',
            'link_url': linkURL,
            'ua_category': 'homepage',
            'ua_action': 'click',
            'ua_label': 'homepage/gtm_homepage_locator_submit'

          };
          break;

        case "home_usemylocation":
          linkURL = "/storelocator";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Use My Location click',
            'link_location': 'hero',
            'link_text': 'Use My Location',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': 'storelocator module',
            'link_url': linkURL,
            'ua_category': 'homepage',
            'ua_action': 'click',
            'ua_label': 'homepage/gtm_homepage_locator_usemy'
          };
          break;

        // AMPMWD-1031
        case "homepage_playaudio":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Tap to hear Toomgis',
            'link_location': 'body',
            'link_text': 'Tap to hear',
            'link_item': 'audio click',
            'link_detail': 'crave-venience',
            'link_action': 'playaudio',
            'link_display': 'icon',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'homepage',
            'ua_action': 'click',
            'ua_label': 'homepage/gtm_homepage_playaudio'
          };
          break;

        case "home_offer":
          linkURL = "/offers";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Fire event upon click of an offer image/tile',
            'link_location': 'body',
            'link_text': element.innerText,
            'link_item': 'offer click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'homepage',
            'ua_action': 'click',
            'ua_label': 'homepage/gtm_homepage_offers'
          };
          break;

        // AMPMWD-924
        case "offers_download_app":
          var offers_download_app = {
            "position": -1,
            "offer": "missing"
          };
          if (typeof varstr !== "undefined") {
            offers_download_app_temp = varstr.split(/\|/g);
            if (offers_download_app_temp.length > 0) {
              offers_download_app.offer = offers_download_app_temp[0];
            }
            if (offers_download_app_temp.length > 1) {
              offers_download_app.position = offers_download_app_temp[1];
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Download App" click',
            'link_location': 'body',
            'link_text': element.innerText,
            'link_item': 'offer click',
            'link_detail': offers_download_app.offer,
            'link_action': 'downloadapp',
            'link_display': 'button',
            'link_position': offers_download_app.position,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'offers',
            'ua_action': 'click',
            'ua_label': 'offers/gtm_offers_cta'
          };
          break;

        // AMPM-1021
        case "scratchpower_iosapp1":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Apple Store App Download',
            'link_location': 'hero',
            'link_text': 'App Store',
            'link_item': 'app download',
            'link_detail': 'ios',
            'link_action': 'downloadapp',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'scratchpower',
            'ua_action': 'click',
            'ua_label': 'scratchpower/gtm_scratchpower_hero_download_ios'
          };
          break;
        case "scratchpower_android1":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Google Play App Download',
            'link_location': 'hero',
            'link_text': 'Google Play',
            'link_item': 'app download',
            'link_detail': 'android',
            'link_action': 'downloadapp',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': 'exit',
            'component_name	': null,
            'link_url': linkURL,
            'ua_category': 'scratchpower',
            'ua_action': 'click',
            'ua_label': 'scratchpower/gtm_scratchpower_hero_download_android'
          }
          break;

        case "scratchpower_rules":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Official Rules" link',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'scratchpower',
            'ua_action': 'click',
            'ua_label': 'scratchpower/gtm_scratchpower_rules'
          }
          break;

        case "scratchpower_faq":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"FAQs" link',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'scratchpower',
            'ua_action': 'click',
            'ua_label': 'scratchpower/gtm_scratchpower_faq'
          };
          break;

        // AMPMWD-1111

        case "scratchpower_appysflyer":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App Download',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'app download',
            'link_detail': null,
            'link_action': 'downloadapp',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'scratchpower',
            'ua_action': 'click',
            'ua_label': 'scratchpower/gtm_scratchpower_appysflyer'
          };
          break;

        case "nhd_storelocator":
          linkURL = "/storelocator";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'store locator submit (nhd)',
            'link_location': 'hero',
            'link_text': 'submit',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': 'storelocator module',
            'link_url': linkURL,
            'ua_category': 'nhd',
            'ua_action': 'click',
            'ua_label': 'nhd/gtm_nhd_locator_submit'
          }
          break;

        case "nhd_mylocation":
          linkURL = "/storelocator";
          if (typeof window.GA4 !== "undefined") {
            if (typeof window.GA4.GlobalFunctions !== "undefined") {
              if (typeof window.GA4.GlobalFunctions.completeRelativeUrl !== "undefined") {
                linkURL = window.GA4.GlobalFunctions.completeRelativeUrl(linkURL);
              }
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Use My Location click (nhd)',
            'link_location': 'hero',
            'link_text': 'Use My Location',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': 'storelocator module',
            'link_url': linkURL,
            'ua_category': 'nhd',
            'ua_action': 'click',
            'ua_label': 'nhd/gtm_nhd_locator_usemy'
          }
          break;

        case "nhd_scratchpower_rules":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Official Rules" link (nhd)',
            'link_location': 'footer',
            'link_text': element.innerText,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': 'app module',
            'link_url': linkURL,
          }
          break;

        case "nhd_scratchpower_faq":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"FAQs" link (nhd)',
            'link_location': 'footer',
            'link_text': element.innerText,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'app module',
            'link_url': linkURL,
          };
          break;

        case "nhd_scratchpower_appysflyer":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App Download (nhd)',
            'link_location': 'footer',
            'link_text': element.innerText,
            'link_item': 'app download',
            'link_detail': null,
            'link_action': 'downloadapp',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': 'exit',
            'component_name': 'app module',
            'link_url': linkURL,
          };
          break;

        // end AMPMWD-1111

        // AMPMWD-926
        case "21ProductsImageClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Products image click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'products click',
            'link_detail': varstr,
            'link_action': null,
            'link_display': 'image',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_img',
            'ua_label': '21products/' + varstr
          };
          break;

        case "21ProductsCTAClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Products "Bottoms Up" button click',
            'link_location': 'body',
            'link_text': element.innerText,
            'link_item': 'products click',
            'link_detail': varstr,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_cta',
            'ua_label': '21products/' + varstr
          };
          break;

        case "21ProductsAppImageClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App image click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'image',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'app tile',
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_image',
            'ua_label': '21products/downloadappcta'
          };
          break;

        case "21ProductsAppCTAClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App "Download Now" button click',
            'link_location': 'body',
            'link_text': 'Download Now',
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'app tile',
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_cta',
            'ua_label': '21products/downloadappcta'
          };
          break;

        case "21ProductsEarnifyImageClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App image click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'image',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'app tile earnify',
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_image',
            'ua_label': '21products/downloadappcta'
          };
          break;

        case "21ProductsEarnifyCTAClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App "Download Now" button click',
            'link_location': 'body',
            'link_text': 'Download Now',
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'app tile earnify',
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_cta',
            'ua_label': '21products/downloadappcta'
          };
          break;

        case "21ProductsUberImageClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Uber image click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'uber click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'image',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_image',
            'ua_label': '21products/ubereats'
          };
          break;

        case "21ProductsUberCTAClick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Uber "Check Availability" button click',
            'link_location': 'body',
            'link_text': 'Check Availability',
            'link_item': 'uber click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL,
            'ua_category': '21products',
            'ua_action': 'click_cta',
            'ua_label': '21products/uber'
          };
          break;


        // AMPMWD-927 -- AMPM-1024
        case "product_back":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'back link click',
            'link_location': 'breadcrumb',
            'link_text': element.innerText,
            'link_item': 'back click',
            'link_detail': null,
            'link_action': 'back',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'back',
            'ua_action': 'click',
            'ua_label': 'back/home'
          };
          break;

        case "product_arrowleft":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'carousel click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'carousel click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'arrow',
            'link_position': 'left',
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'carousel',
            'ua_action': 'click',
            'ua_label': 'carousel/arrow/left'
          };
          break;

        // AMPMWD-1027
        case "product_arrowright":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'carousel click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'carousel click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'arrow',
            'link_position': 'right',
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'carousel',
            'ua_action': 'click',
            'ua_label': 'carousel/arrow/right'
          };
          break;

        case "product_dot":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'carousel click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'carousel click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'dot',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'carousel',
            'ua_action': 'click',
            'ua_label': 'carousel/dot'
          };
          break;

        // AMPMWD-932
        // case "toomgisHotSpotsCTA":
        //   event = {
        //     'event': 'ga4_custom_link',
        //     'custom_link': 'click to open Toomgis body parts',
        //     'link_location': 'hero',
        //     'link_text': null,
        //     'link_item': 'discover toomgis click',
        //     'link_detail': varstr,
        //     'link_action': null,
        //     'link_display': 'icon',
        //     'link_position': null,
        //     'link_conversion': 0,
        //     'link_type': null,
        //     'component_name': null,
        //     'link_url': null,
        //     'ua_category': 'tommgis',
        //     'ua_action': 'click',
        //     'ua_label': 'tommgis/click/' + varstr
        //   };
        //   break;

        // AMPMWD-933
        case "storelocator_result":
          event = {
            'event': 'ga4_location_lookup',
            'location_lookup': varstr,
            'ua_category': 'locator',
            'ua_action': 'results',
            'ua_label': 'locator/' + varstr
          };
          break;

        case "storelocator_search":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Arrow" button click (or keyboard enter) for store locator',
            'link_location': 'body',
            'link_text': 'submit',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'storelocator/submit'
          };
          break;

        case "storelocator_usemylocation":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Use My Location click',
            'link_location': 'body',
            'link_text': 'Use My Location',
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': null,
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'storelocator/usemylocation'
          };
          break;

        case "storelocator_storeclick_call":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'phone number click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'store click',
            'link_detail': 'phone number',
            'link_action': 'callstore',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': 'stores list',
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'storelocator/result_call'
          };
          break;

        // remove this one "storelocator_storeclick"
        case "storelocator_storeclick_address":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'address click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'store click',
            'link_detail': 'address',
            'link_action': 'zoom map',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': 'stores list',
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'storelocator/result_address'
          };
          break;

        case "storelocator_storeclick_distance":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'distance (xx mi.) click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'store click',
            'link_detail': 'distance',
            'link_action': 'zoom map',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'stores list',
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'storelocator/result_distance'
          };
          break;

        case "storelocator_storeclick_direction":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'directions click',
            'link_location': 'body',
            'link_text': null,
            'link_item': 'store click',
            'link_detail': 'directions',
            'link_action': 'zoom map',
            'link_display': 'icon',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'stores list',
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'storelocator/result_directions'
          };
          break;

        // remove this one "storelocator_direction"
        case "storelocator_directions":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'directions click within map',
            'link_location': 'map',
            'link_text': 'directions',
            'link_item': 'store click',
            'link_detail': 'directions',
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'map',
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'map/directions'
          };
          break;
        case "storelocator_call":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'call click within map',
            'link_location': 'map',
            'link_text': null,
            'link_item': 'store click',
            'link_detail': 'phone number',
            'link_action': 'callstore',
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': 'map',
            'link_url': null,
            'ua_category': 'storelocator',
            'ua_action': 'click',
            'ua_label': 'map/call'
          };
          break;
        // App Page
        case "earnify_appysflyer":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'App Download',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'app download',
            'link_detail': null,
            'link_action': 'downloadapp',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 1,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL
          };
          break;
        case "earnify_rules":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"Official Rules" link',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL,
            'ua_category': 'scratchpower',
            'ua_action': 'click',
            'ua_label': 'scratchpower/gtm_scratchpower_rules'
          }
          break;
        case "earnify_faq":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '"FAQs" link',
            'link_location': 'hero',
            'link_text': element.innerText,
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL
          };
          break;
        case "earnify_learnmore":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': '',
            'link_location': 'hero',
            'link_text': 'Learn More',
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': 'exit',
            'component_name': null,
            'link_url': linkURL
          };
          break;

        // Region Modal
        // (click is passed, data-region provides selected region)
        case "regiongate_regionclick":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'region selection button',
            'link_location': 'modal',
            'link_text': element.innerText,
            'link_item': 'region click',
            'link_detail': null,
            'link_action': 'setregion',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'region selector-select region',
            'link_url': null
          };

          if (element.getAttribute("data-region")) {
            document.cookie = "taggingEarnifyRegion" + "=" + (element.getAttribute("data-region") || "") + "; path=/";
          }
          break;


        case "regiongate_zipcodeoption":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'or enter ZIP code link',
            'link_location': 'modal',
            'link_text': element.innerText,
            'link_item': "region click",
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'region selector-select region',
            'link_url': linkURL
          };
          trackGA4(null, 'regiongate_zip_modalopen');
          break;
        case "regiongate_selectregion":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'or select region link',
            'link_location': 'modal',
            'link_text': element.innerText,
            'link_item': "region click",
            'link_detail': null,
            'link_action': null,
            'link_display': 'text',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'region selector-zipcode',
            'link_url': linkURL
          };
          trackGA4(null, 'regiongate_modalopen');
          break;
        case "regiongate_modalopen":
          event = {
            'event': 'ga4_banner_display',
            'banner_display': 'region selector display',
            'link_location': 'modal',
            'component_name': 'region selector-select region'
          };
          break;
        case "regiongate_zip_modalopen":
          event = {
            'event': 'ga4_banner_display',
            'banner_display': 'zip selector display',
            'link_location': 'modal',
            'component_name': 'region selector-zipcode'
          };
          break;
        case "regiongate_modalclose":
          break;
        //  (zip is passed)
        case "regiongate_zipsubmit":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Arrow button click (or keyboard enter)',
            'link_location': 'modal',
            'link_text': 'submit',
            'link_item': 'region click',
            'link_detail': null,
            'link_action': 'setregion',
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': 'region selector-zipcode',
            'link_url': linkURL
          };
          break;
        // (isEarify is passed)
        case "regiongate_zipelegible":
          break;

        // 21+
        // The App tiles is marked with  data-current-app="earnify" or  data-current-app="ampm" accordingly

        // Footer
        // (earnify learn more)
        case "global_earnify":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Learn More click (earnify)',
            'link_location': 'footer',
            'link_text': 'Learn More',
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': "app module earnify",
            'link_url': linkURL
          };
          break;
        // (ampm learn more)
        case "global_scratchpower":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Learn More click (ampm)',
            'link_location': 'footer',
            'link_text': 'Learn More',
            'link_item': 'app click',
            'link_detail': null,
            'link_action': null,
            'link_display': 'button',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': "app module",
            'link_url': linkURL
          };
          break;

        case "storelocator_bannerclick":
          var bannerLinkText = "See Offers";
          var bannerLinkDetail = "offers";
          if(element) {
            if(element.querySelector("img[alt]")) {
              bannerLinkText =  element.querySelector("img[alt]").getAttribute("alt");
              bannerLinkDetail = element.querySelector("img[alt]").getAttribute("alt").toLowerCase().replace(/[^a-zA-Z0-9-&\s]/g, '').replace(/\s+/g, '-').trim();
            }
          }
          if(element) {
            if(element.querySelector("img[data-link-text]")) {
              bannerLinkText =  element.querySelector("img[data-link-text]").getAttribute("data-link-text");
            }
          }
          if(element) {
            if(element.querySelector("img[data-link-detail]")) {
              bannerLinkDetail = element.querySelector("img[data-link-detail]").getAttribute("data-link-detail").toLowerCase().replace(/[^a-zA-Z0-9-&\s]/g, '').replace(/\s+/g, '-').trim();
            }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'locator page banner',
            'link_location': 'hero',
            'link_text': bannerLinkText,
            'link_item': 'banner click',
            'link_detail': bannerLinkDetail,
            'link_action': null,
            'link_display': 'image',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': null,
            'link_url': linkURL
          };
          break;
        case "storelocator_themeclick":
          var dayOrNight = "day";
          if(document.querySelector("#map button.map-theme-toggle")) {
          if(document.querySelector("#map button.map-theme-toggle").classList.contains("is-dark")) {
             dayOrNight = "night";
             }
          }
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'day night toggle',
            'link_location': 'map',
            'link_text': null,
            'link_item': 'map click',
            'link_detail': dayOrNight,
            'link_action': 'change mode',
            'link_display': 'icon',
            'link_position': null,
            'link_conversion': 0,
            'link_type': null,
            'component_name': "map",
            'link_url': null
          };
          break;
        case "storelocator_usemylocation":
          event = {
            'event': 'ga4_custom_link',
            'custom_link': 'Use My Location click',
            'link_location': 'map',
            'link_text': null,
            'link_item': 'locator submit',
            'link_detail': null,
            'link_action': 'locatestore',
            'link_display': 'icon',
            'link_position': null,
            'link_conversion': 1,
            'link_type': null,
            'component_name': "storelocator",
            'link_url': null
          };
          break;
      }

      window.dataLayer = window.dataLayer || [];
      if (typeof window.dataLayer != "undefined") {
        window.dataLayer.push(event);
      }
    };

